import { cn } from '@/lib/utils';
import clsx from 'clsx';
import { cva, cx } from 'cva';
import React from 'react';

const skeleton = cva('skeleton', {
  variants: {
    variant: {
      circle: [],
      rect: ['w-full rounded'],
    },
    size: {
      xs: [],
      sm: [],
      md: [],
      lg: [],
      xl: [],
    },
    color: {
      default: ['bg-gray-200'],
      primary: ['bg-primary'],
      'primary-light': ['bg-primary-light-1'],
      secondary: ['bg-secondary'],
      'secondary-light': ['bg-secondary-light-1'],
    },
  },
  compoundVariants: [
    {
      variant: 'circle',
      size: 'xs',
      className: 'h-6 w-6 rounded-full',
    },
    {
      variant: 'circle',
      size: 'sm',
      className: 'h-12 w-12 rounded-full',
    },
    {
      variant: 'circle',
      size: 'md',
      className: 'h-16 w-16 rounded-full',
    },
    {
      variant: 'circle',
      size: 'lg',
      className: 'h-24 w-24 rounded-full',
    },
    {
      variant: 'circle',
      size: 'xl',
      className: 'h-32 w-32 rounded-full',
    },
    {
      variant: 'rect',
      size: 'xs',
      className: 'h-6',
    },
    {
      variant: 'rect',
      size: 'sm',
      className: 'h-12',
    },
    {
      variant: 'rect',
      size: 'md',
      className: 'h-16',
    },
    {
      variant: 'rect',
      size: 'lg',
      className: 'h-24',
    },
    {
      variant: 'rect',
      size: 'xl',
      className: 'h-32',
    },
  ],
  defaultVariants: {
    variant: 'rect',
    size: 'md',
    color: 'default',
  },
});

function Skeleton(props) {
  const { variant, size, color, className } = props;
  return (
    <div
      role="status"
      className={cn(
        skeleton({ variant, size, color }),
        'animate-pulse',
        className,
      )}></div>
  );
}

export default Skeleton;
